import React from 'react';
interface MeetTheExpertProps {
  openContactForm: () => void;
}
export function MeetTheExpert({
  openContactForm
}: MeetTheExpertProps) {
  return <section className="w-full py-24 sm:py-32 px-6 sm:px-8 bg-slate-100" data-id="element-140">
      <div className="max-w-6xl mx-auto" data-id="element-141">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-142">
          {/* Image side */}
          <div className="relative order-2 lg:order-1" data-id="element-143">
            <div className="aspect-[4/5] rounded-lg overflow-hidden relative" data-id="element-144">
              <img src="https://cdn.magicpatterns.com/uploads/x7ZTiQH6T7XpqXN9EZ4fZ2/c8a2c6e1-9da3-4061-9fe6-5a81b393c2c4.jpg" alt="Gavin Smith, CFA" className="w-full h-full object-cover" data-id="element-145" />

              {/* CFA credential overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-navy-900 via-navy-900/90 to-transparent" data-id="element-146">
                <div className="flex items-center gap-4" data-id="element-147">
                  <img src="https://cdn.magicpatterns.com/uploads/9AhjtHWfNw3ygYAXnjgKdT/CFA_logo.png" alt="CFA Institute" className="w-14 h-14 object-contain" data-id="element-148" />
                  <div data-id="element-149">
                    <div className="text-white font-semibold" data-id="element-150">
                      CFA Charterholder
                    </div>
                    <div className="text-slate-400 text-sm" data-id="element-151">
                      Chartered Financial Analyst
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative frame */}
            <div className="absolute -top-4 -left-4 w-full h-full border border-gold-500/20 rounded-lg -z-10" data-id="element-152" />
          </div>

          {/* Content side */}
          <div className="order-1 lg:order-2" data-id="element-153">
            <p className="text-gold-500 text-sm font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-154">
              Meet the Expert
            </p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-navy-900 mb-6 leading-tight" data-id="element-155">
              Gavin Smith, CFA
            </h2>

            <div className="space-y-5 text-slate-600 text-[16px] leading-relaxed mb-8" data-id="element-156">
              <p data-id="element-157">
                I am an{' '}
                <span className="text-navy-900 font-medium" data-id="element-158">
                  operator-investor
                </span>{' '}
                with a hybrid finance-operations background who steps into
                complex, under-professionalized businesses to build durable
                systems.
              </p>
              <p data-id="element-159">
                Unlike traditional consultants, I've sat on both sides of the
                table—as an investor valuing fund positions and as an{' '}
                <span className="text-navy-900 font-medium" data-id="element-160">interim CFO</span>{' '}
                professionalizing SOPs after an acquisition.
              </p>
              <p data-id="element-161">
                I pair rigorous financial plumbing (LBO modeling, GAAP revenue
                recognition) with hands-on growth execution (AI-enabled
                outbound, SEO, and pricing strategy) to compound cash flow and
                value.
              </p>
              <p className="text-navy-900 font-medium italic border-l-2 border-gold-500 pl-4" data-id="element-162">
                I specialize in helping SMBs bridge the gap between "good
                enough" bookkeeping and institutional-grade financial
                leadership.
              </p>
            </div>

            <a href="https://calendar.app.google/QG1eQrZMQfAuXDhF8" target="_blank" rel="noopener noreferrer" className="inline-block bg-navy-900 text-white px-8 py-4 font-semibold rounded hover:bg-gold-500 hover:text-navy-900 transition-all duration-300 text-[15px]" data-id="element-163">
              Schedule a Conversation
            </a>
          </div>
        </div>
      </div>
    </section>;
}